import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';

export const ErrorString = ({
  error,
}) => (
  <Fragment>
    <Text variant="small" className="error-string" block styles={{ root: { color: '#A80000', whiteSpace: 'break-spaces', lineHeight: '18px' } }}>{error}</Text>
  </Fragment>
);

ErrorString.propTypes = {
  error: PropTypes.string,
};
ErrorString.defaultProps = {
  error: '',
};

